// extracted by mini-css-extract-plugin
module.exports = {"context":"Context_context__rBvvC","statementList":"Context_statementList__bLX2C"};